var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cbo-headerfake"},[_c('v-spacer'),_c('router-link',{staticClass:"headerfake-logo",attrs:{"to":"/"}},[_c('v-img',{attrs:{"src":require("../assets/images/logo-white.png"),"alt":""}})],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }